import IMask from 'imask';
import APIV5 from '~/models/api';

export default class kidController {
	#$copyToClipboard;

	#$timeout;

	#$translate;

	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} User
	 * @param {import('angular').IRootElementService} $element
	 */
	constructor(
		$copyToClipboard,
		$timeout,
		$translate,
		User,
		$element,
	) {
		/** @type {string} */
		this.kid = '';

		/** @type {boolean} */
		this.loading = false;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {?Function} */
		this.onSelect = null;

		/** @type {string} */
		this.placeholder = '';

		/** @type {import('@knitiv/api-client-javascript').Structure} */
		this.prefix = 'K_NODE';

		/** @type {boolean} */
		this.required = false;

		this.#$copyToClipboard = $copyToClipboard;
		this.#$timeout = $timeout;
		this.#$translate = $translate;
		this.User = User;
		this.$element = $element;
	}

	/**
	 * @param {Event} event
	 */
	copy(event) {
		// @ts-ignore
		this.kid = event.target?.value;
		this.#$copyToClipboard(`${this.prefix};${this.kid}`, false);
	}

	async genKid() {
		this.loading = true;
		const result = await APIV5.instance.kidNew({ structure: this.prefix }, { id: 'kid.gen-kid' });
		this.loading = false;
		this.kid = result ? result.kid.split(';')[1] : '';
		this.update();
	}

	/**
	 * @param {ClipboardEvent} event
	 */
	paste(event) {
		// @ts-ignore
		const inputValue = event.originalEvent.clipboardData.getData('text');
		if (inputValue.startsWith(`${this.prefix};`)) {
			event.preventDefault();
			this.#$timeout(() => {
				this.kid = inputValue.split(';')[1];
				return this.update();
			});
		}
	}

	select() {
		if (typeof this.onSelect === 'function') {
			this.onSelect({ $item: { kid: `${this.prefix};${this.kid}` } });
		}
	}

	update() {
		this.#$timeout(() => {
			if (typeof this.kid === 'string' && this.kid.trim() !== '') {
				this.ngModelCtrl?.$setViewValue(`${this.prefix};${this.kid}`);
			}
			else {
				this.ngModelCtrl?.$setViewValue(undefined);
			}
		});
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.kid) {
			this.update();
		}
	}

	$onInit() {
		if (!this.prefix) {
			this.prefix = 'K_NODE';
		}

		if (!this.placeholder) {
			this.placeholder = this.#$translate.instant('oo.identifiant');
		}

		if (!this.options) {
			this.options = {
				button: 'genKid',
			};
		}

		this.ngModelCtrl?.$formatters.push(data => {
			const r = /^([A-Z_]+);(.+)$/.exec(data);
			if (r) {
				// @ts-ignore
				[, this.prefix, this.kid] = r;
			}
			else {
				this.kid = '';
			}
			return data;
		});

		/** @type {any} */
		const element = this.$element.find('input').get(0);
		IMask(element, {
			mask: /^(\w{1,30})$/,
		});
	}
}
